/**
 * Welle 126 — gestellte Rechnung per E-Mail senden (Postfach rechnung@immo.holthey.de).
 * Vorschlag (Empfänger-Mail aus den Stammdaten, Betreff, Text) laden, änderbar; nach dem Senden zeigt das Protokoll,
 * was passiert ist: Mail an wen, Datei aus dem Batch Output in den richtigen Ordner verschoben, Kopie für DATEV.
 * Ohne Senden bleibt alles wie bisher: Datei im Batch Output, selbst herunterladen und weiterverarbeiten.
 */
import React, { useEffect, useState } from "react";
import { API, json } from "./hilfen";
import Ico from "./Ico";

export function VersandProtokoll({ protokoll }) {
  if (!protokoll?.length) return null;
  return (
    <ul className="rg-protokoll">
      {protokoll.map((p, i) => (
        <li key={i} className={p.ok === false ? "warn" : ""}><Ico n={p.ok === false ? "warnung" : "haken"} /> {p.text}</li>
      ))}
    </ul>
  );
}

export default function MailVersand({ rid, onGesendet }) {
  const [v, setV] = useState(null);
  const [offen, setOffen] = useState(false);
  const [an, setAn] = useState("");
  const [betreff, setBetreff] = useState("");
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [fehler, setFehler] = useState("");
  const [ergebnis, setErgebnis] = useState(null);
  const [frage, setFrage] = useState(false);

  useEffect(() => {
    if (!rid) return;
    fetch(`${API}/${rid}/mail-vorschlag`).then(json).then((d) => {
      setV(d); setAn(d.an || ""); setBetreff(d.betreff || ""); setText(d.text || "");
    }).catch((e) => setFehler(String(e.message || e)));
  }, [rid]);

  const senden = async () => {
    setFrage(false); setBusy(true); setFehler("");
    try {
      const d = await json(await fetch(`${API}/${rid}/mail`, { method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ an, betreff, text }) }));
      setErgebnis(d); setV((x) => ({ ...x, versand: d.versand }));
      onGesendet && onGesendet(d);
    } catch (e) { setFehler(String(e.message || e)); }
    setBusy(false);
  };

  if (!v) return fehler ? <div className="mb-meldung fehler">{fehler}</div> : null;
  const postfach = v.postfach || {};
  return (
    <div className="mb-sektion rg-mailversand">
      <div className="mb-sektion-titel">Per E-Mail senden</div>
      {v.versand && !ergebnis && (
        <p className="rg-klein" style={{ marginTop: 0 }}><Ico n="haken" /> Gesendet am {v.versand.am} an <b>{v.versand.an}</b>.</p>
      )}
      {!offen && !ergebnis && (
        <div className="rg-knoepfe">
          <button type="button" className="mb-btn primary" disabled={!postfach.verfuegbar} onClick={() => setOffen(true)}
            title={postfach.verfuegbar ? `von ${postfach.absender}` : postfach.hinweis}>
            <Ico n="verbinden" /> {v.versand ? "Noch einmal senden …" : "Per E-Mail senden …"}</button>
          <span className="rg-klein" style={{ margin: 0 }}>
            {postfach.verfuegbar ? "Danach liegt die Datei im richtigen Ordner (statt im Batch Output) + Kopie für DATEV."
              : postfach.hinweis}</span>
        </div>
      )}
      {offen && !ergebnis && (
        <div className="mb-felder">
          <label className="mb-feld rg-breit"><span className="mb-label">An</span>
            <input className="mb-input" value={an} placeholder="E-Mail des Empfängers" onChange={(e) => setAn(e.target.value.trim())} /></label>
          <label className="mb-feld rg-breit"><span className="mb-label">Betreff</span>
            <input className="mb-input" value={betreff} onChange={(e) => setBetreff(e.target.value)} /></label>
          <label className="mb-feld rg-breit"><span className="mb-label">Text (das PDF hängt an)</span>
            <textarea className="mb-input rg-area" rows={7} style={{ height: "auto", minHeight: 150 }} value={text} onChange={(e) => setText(e.target.value)} /></label>
          <div className="rg-knoepfe" style={{ gridColumn: "1 / -1" }}>
            <button type="button" className="mb-btn primary" disabled={busy || !/@/.test(an)} onClick={() => setFrage(true)}>
              {busy ? "sendet …" : "Senden"}</button>
            <button type="button" className="mb-link" onClick={() => setOffen(false)}>abbrechen</button>
          </div>
          {frage && (
            <div className="rg-frage" style={{ gridColumn: "1 / -1" }}>
              <b>Rechnung jetzt an {an} senden?</b>
              <div className="rg-klein" style={{ margin: 0 }}>Absender {postfach.absender}; danach wird die Datei aus dem Batch Output in den richtigen Ordner verschoben und für DATEV kopiert.</div>
              <div className="rg-knoepfe"><button type="button" className="mb-btn primary" onClick={senden}>Ja, senden</button>
                <button type="button" className="mb-btn" onClick={() => setFrage(false)}>Abbrechen</button></div>
            </div>
          )}
        </div>
      )}
      {fehler && <div className="mb-meldung fehler">{fehler}</div>}
      {ergebnis && (<><div className="mb-meldung ok">Gesendet — das wurde gemacht:</div><VersandProtokoll protokoll={ergebnis.protokoll} /></>)}
    </div>
  );
}
